module.exports = __webpack_public_path__ + "img/publish.454f6e3f.svg";